import R from 'app/assets/R'
import { BaseManagementWrapper } from 'app/components/tables/BaseTableManagement/styles'
import React, { useState } from 'react'
import { useModalHook } from './hooks'
import {
  Cancel,
  CreateRequestExportBill,
  Exported,
  HeadTabComponent,
  NeedUpdate,
  WaitingForExport,
} from './layouts'
import { BaseTabsExportBill } from './styles'

export const ExportBillContainer: React.FC = () => {
  const [tabKey, setTabKey] = useState(R.strings.waiting_for_export)
  const [reloadTable, setReloadTable] = useState(0)
  const {
    pendingCount,
    completeCount,
    needUpdateCount,
    canceledCount,
    handleExportExcel,
    exportPermission,
  } = useModalHook({ reloadCount: reloadTable })

  return (
    <BaseManagementWrapper>
        <BaseTabsExportBill
          defaultActiveKey={tabKey}
          tabPosition={'top'}
          onChange={setTabKey}
          tabBarExtraContent={
            <CreateRequestExportBill setReloadTable={setReloadTable} />
          }
          items={[
            {
              label: (
                <HeadTabComponent
                  keyTitle={R.strings.waiting_for_export}
                  total={pendingCount}
                  currentTab={tabKey}
                />
              ),
              key: R.strings.waiting_for_export,
              children: (
                <WaitingForExport
                  reloadTable={reloadTable}
                  exportPermission={exportPermission}
                  handleExportExcel={handleExportExcel}
                  setReloadTable={setReloadTable}
                />
              ),
            },
            {
              label: (
                <HeadTabComponent
                  keyTitle={R.strings.exported}
                  total={completeCount}
                  currentTab={tabKey}
                />
              ),
              key: R.strings.exported,
              children: (
                <Exported
                  reloadTable={reloadTable}
                  exportPermission={exportPermission}
                  handleExportExcel={handleExportExcel}
                  setReloadTable={setReloadTable}
                />
              ),
            },
            {
              label: (
                <HeadTabComponent
                  keyTitle={R.strings.need_update}
                  total={needUpdateCount}
                  currentTab={tabKey}
                />
              ),
              key: R.strings.need_update,
              children: (
                <NeedUpdate
                  reloadTable={reloadTable}
                  exportPermission={exportPermission}
                  handleExportExcel={handleExportExcel}
                  setReloadTable={setReloadTable}
                />
              ),
            },
            {
              label: (
                <HeadTabComponent
                  keyTitle={R.strings.cancel}
                  total={canceledCount}
                  currentTab={tabKey}
                />
              ),
              key: R.strings.cancel,
              children: (
                <Cancel
                  reloadTable={reloadTable}
                  exportPermission={exportPermission}
                  handleExportExcel={handleExportExcel}
                />
              ),
            },
          ]}
        />
    </BaseManagementWrapper>
  )
}
